export default __webpack_public_path__ + "static/media/my_journey_part2_2.682d027d.png";